module.exports = __webpack_public_path__ + "static/media/ebike.e3fd1a55.png";